import { render, staticRenderFns } from "./ElsaBaseTableLayout.vue?vue&type=template&id=04671a6c&scoped=true&"
import script from "./ElsaBaseTableLayout.vue?vue&type=script&lang=js&"
export * from "./ElsaBaseTableLayout.vue?vue&type=script&lang=js&"
import style0 from "./ElsaBaseTableLayout.vue?vue&type=style&index=0&id=04671a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04671a6c",
  null
  
)

export default component.exports